import React from "react";
import Jumbotron from "react-bootstrap/Jumbotron";
import Container from "react-bootstrap/Container";
import styled from "styled-components";
import Image from "react-bootstrap/Image";
import expand_more_24px from "../images/expand_more_24px.png";
import TMDMWhite from "../images/TMDMWhite.png";
import TypeIt from "typeit-react";

const StyledJumbotron = styled(Jumbotron)`
  color: white;
  height: 100vh;
  margin-bottom: 0px;
  align-items: center;
  text-align: left;
  position: relative;
  overflow: hidden;
`;

const MainTitle = styled.h1`
  margin: 0 auto;
  font-size: calc(32px + 8vw);
  padding-bottom: 2rem;
  color: rgb(255, 255, 255);
`;

const MainCaption = styled.h1`
  border: 0;
  position: absolute;
  bottom: 28%;
  margin-left: 10%;
  font-size: calc(12px + 2vw);
  color: rgb(255, 255, 255);
`;

const BottomExpandImage = styled(Image)`
  border: 0;
  position: absolute;
  bottom: 10%;
  margin-left: calc(50% - 35px);
`;

const TmdLogoImageWrapper = styled(Container)`
  border: 0;
  position: absolute;
  top: 0%;
  margin-left: 0%;
`;

const LandingPage = ({ text, title, handleBottomExpandClick }) => {
  return (
    <StyledJumbotron
      fluid
      style={{
    
        background: "linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(https://www.michigandaily.com/sites/default/files/styles/large/public/200914/skylinecolor-01_0.png?itok=WC2cg2fY) no-repeat center center",
        backgroundSize: "cover",
      }}
    >
      <TmdLogoImageWrapper style={{ opacity: "100%"}}>
        <a href="https://www.michigandaily.com/">
          <Image src={TMDMWhite} fluid />
        </a>
      </TmdLogoImageWrapper>
      <Container
        style={{
          marginLeft: "10%",
          marginRight: "0%",
          position: "absolute",
          bottom: "40%",
          padding: "0"
        }}
      >
        <TypeIt
          options={{
            speed: 150,
            waitUntilVisible: true,
            cursor: false
          }}
        >
          <MainTitle className="display-1">{title}</MainTitle>
        </TypeIt>
      </Container>

      <MainCaption>{text}</MainCaption>

      <BottomExpandImage
        src={expand_more_24px}
        onClick={handleBottomExpandClick}
      />
    </StyledJumbotron>
  );
};

export default LandingPage;
